<template>
  <div class="solutionsDetail">
    <div class="text">
      <h2>5G Smart Park</h2>
      <p>
        Adopting integrated 5G Base Station and customized industrial CPE
        terminal, the 5G Smart Park solution builds private 5G networks for
        companies together with telecom operators. The 5G Smart Park solution
        makes full use of operators’ spectrum resources and helps expand 5G
        industry application for operators. At the same time, the solution can
        also promote 5G service experiences and guarantee the data security for
        companies and customers.
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.solutionsDetail {
  padding: 50px 100px;
  .text {
    h2 {
      text-align: center;
      margin-bottom: 30px;
      font-size: 32px;
    }
  }
}
</style>
